import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectIsSmartBannerExperimentEnabled } from '../../selectors/experiments/selectIsSmartBannerExperimentEnabled';
import { EMobileDeviceType } from '../../types/mobileDeviceType';
import { useApplicationContext } from '../../utils/applicationContext';

export function useGetIsSmartBannerEnabled(): boolean {
  const { config, custom } = useApplicationContext();
  const isSmartBannerEnabled = config.get<boolean>('SmartBanner.Enabled') ?? false;

  const isSmartBannerExperimentEnabled = useSelector(selectIsSmartBannerExperimentEnabled);

  return useMemo(() => {
    return (
      isSmartBannerEnabled &&
      isSmartBannerExperimentEnabled &&
      custom.mobileDeviceType === EMobileDeviceType.iOS &&
      custom.isSafari
    );
  }, [isSmartBannerEnabled, isSmartBannerExperimentEnabled, custom.mobileDeviceType, custom.isSafari]);
}
